"use client";

import Link from "next/link";
import { btn } from "@/lib/button-styles";
import { useT } from "@/lib/i18n/client";

export default function ErrorPage({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useT();
  const e = t.errorPages;
  return (
    <section className="mx-auto max-w-[700px] px-4 py-24 text-center sm:px-7">
      <h1 className="font-display text-[clamp(36px,6vw,56px)] leading-[1] text-foreground">{e.errorTitle}</h1>
      <p className="mt-5 text-lg text-muted-foreground">{e.errorBody}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <button type="button" onClick={reset} className={btn("primary", "md")}>
          {e.retry}
        </button>
        <Link href="/" className={btn("light", "md")}>
          {e.backHome}
        </Link>
        <Link href="/trainers" className={btn("light", "md")}>
          {e.findTrainer}
        </Link>
      </div>
    </section>
  );
}
